import requests from "@/request";


/**
 * 下载文件
 * @param url
 * @param params
 * @returns {Promise<unknown>}
 */
export function downloadTemplateFile(url,params) {
    return requests({
        url: url,
        data: params,
        responseType: "blob",
    }).then((res) => {
        console.log(res.headers,"1111111111")
        // console.log(decodeURI(res.headers['content-disposition'].split(';')[1].split("=")[1]))
        const link = document.createElement('a')
        const blob = new Blob([res.data])
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob,{type:res.data.type})
        let fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split("=")[1])
        link.setAttribute("download",fileName);
        link.click()
        URL.revokeObjectURL(link.href) //释放内存
    });
}

/**
 * 下载文件
 * @param url 请求地址
 * @param requestParams 请求参数key值
 * @param data id或者id数组
 */
export function downloadFile(url,requestParams,data,formName,showId,downLoadFileParams,name) {
    console.log(Object.prototype.toString.call(data))
    let arr = []
    if (data instanceof Object){
        arr.push(data)
    }
    if (data instanceof Array){
        for (let i = 0; i < data.length; i++) {
            arr.push(data[i])
        }
    }
    console.log(arr)
    arr.map((item) => {
        let obj = {}
        obj[requestParams] = item
        let id = ""
        if (downLoadFileParams){
            id = item[downLoadFileParams]
        }else {
            id = item.id
        }
        return requests({
            url:url,
            responseType: "blob",
            params:{
                id:id,
                formName:formName,
                showId:showId
            },
            // data:obj
        }).then((res) => {
            console.log(res)
            const link = document.createElement('a')
            const blob = new Blob([res.data])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob,{type:res.data.type})
            let fileName = ""
            if (name){
                fileName = name
            }else {
                fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split("=")[1])
            }
            link.setAttribute("download", fileName);
            link.click()
            URL.revokeObjectURL(link.href) //释放内存
        });
    })

}

/**
 * 下载文件通过地址下载
 * @param url 请求地址
 * @param requestParams 请求参数key值
 * @param data id
 */
export function downloadUrlFile(url,requestParams,data) {
    let arr = []
    if (data instanceof Object){
        arr.push(data)
    }
    if (data instanceof Array){
        for (let i = 0; i < data.length; i++) {
            arr.push(data[i].id)
        }
    }
    console.log(arr)
    arr.map((item) => {
        let obj = {}
        obj[requestParams] = item
        return requests({
            url:url,
            responseType: "blob",
            params:{
                id:item.id
            },
        }).then((res) => {
            console.log(res)
            const link = document.createElement('a')
            const blob = new Blob([res.data])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob,{type:res.data.type})
            let fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split("=")[1])
            link.setAttribute("download", fileName);
            link.click()
            URL.revokeObjectURL(link.href) //释放内存
        });
    })

}


/**
 * 下载文件
 * @param url 请求地址
 * @param data id或者id数组
 */
export function downloadFiles(url,data) {
    console.log(data)
    data.map((item) => {
        return requests({
            url:url,
            responseType: "blob",
            params:{
                id:item
            },
        }).then((res) => {
            console.log(res)
            const link = document.createElement('a')
            const blob = new Blob([res.data])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob,{type:res.data.type})
            let fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split("=")[1])
            link.setAttribute("download", fileName);
            link.click()
            URL.revokeObjectURL(link.href)
        });
    })

}



